// extracted by mini-css-extract-plugin
module.exports = {"wrapperShowFavorite":"ShowFavorite_wrapperShowFavorite__1oDCc"};